import React, { useState, useEffect, useRef } from "react";
import { Slider, Button } from "antd";
import {
  StepBackwardOutlined,
  PlayCircleOutlined,
  PauseCircleOutlined,
  StepForwardOutlined,
} from "@ant-design/icons";
import { ReactComponent as Playbackward } from "../../../src/assets/livetracking/playbackward.svg";
import { ReactComponent as PlayForward } from "../../../src/assets/livetracking/playforward.svg";
import { ReactComponent as Pause } from "../../../src/assets/livetracking/Pause.svg";
import styled from "styled-components";


const Trackingplaybackz = styled.div`
/* .ant-slider .ant-slider-track {
  background-color: green !important;
} */
.ant-slider .ant-slider-rail {
  background-color: lightgray !important;
}
.ant-slider .ant-slider-track {
  background-color: gold !important; 
  height: 8px; 
}
.ant-slider .ant-slider-handle {

   width: 4px;             
  height: 40px;              
  /* background-color: limegreen !important; */
  border: none !important;
  box-shadow: none !important; 
    margin-top:-14px !important;
}
.ant-slider .ant-slider-handle::after {width: 0px !important;
    height:40px !important;
    margin-top:-14px !important;
    display: none !important;;
}

`
const Trackingplayback = ({ totalPoints = 100, onPositionChange }) => {
  console.log(totalPoints , "totalPoints")

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const intervalRef = useRef(null);
console.log(intervalRef , "intervalRef")


  
  useEffect(() => {
    if (isPlaying) {
      intervalRef.current = setInterval(() => {
        setCurrentIndex((prev) => {
        console.log(totalPoints , "totalPoints")

          if (prev < totalPoints - 1) {
            return prev + 1;
          } else {
            clearInterval(intervalRef.current);
            setIsPlaying(false);
            return prev;
          }
        });
      }, 500); // speed (ms) per step
    } else {
      clearInterval(intervalRef.current);
    }
    return () => clearInterval(intervalRef.current);
  }, [isPlaying, totalPoints]);

  // Notify parent when position changes (e.g., update map marker)
  useEffect(() => {
    if (onPositionChange) {
      onPositionChange(currentIndex);
    }
  }, [currentIndex, onPositionChange]);

  return (<>
 
    <Trackingplaybackz>
    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      {/* Slider */}
      <Slider
        min={0}
        max={totalPoints - 1}
        value={currentIndex}
        onChange={setCurrentIndex}
        style={{ flexGrow: 1 }}
      />

      {/* Counter */}
      <span>
        {console.log(totalPoints , "totalPoints")}
        {currentIndex + 1}/{totalPoints}
      </span>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "12px",
          width: "100%",
        }}
      >
        {/* Backward */}

        <div onClick={() => setCurrentIndex((i) => Math.max(0, i - 1))}>
          <Playbackward />
        </div>

        {/* Play/Pause */}

        <div onClick={() => setIsPlaying((p) => !p)}>
          {isPlaying ? <Pause /> : <Pause />}
        </div>

        {/* Forward */}
        <div
          onClick={() =>
            setCurrentIndex((i) => Math.min(totalPoints - 1, i + 1))
          }
        >
          <PlayForward />
        </div>
      </div>
    </div>
    </Trackingplaybackz></>
  );
};

export default Trackingplayback;
